module.exports = __webpack_public_path__ + "img/IMAGE 8.acc786ea.png";